const BODY_AREA_PARENT_BY_LABEL = {
    'Skull & Head': 'Head and Neck',
    Neck: 'Head and Neck',
    'Hip & Pelvis': 'Lower Limb',
    Knee: 'Lower Limb',
    'Foot & Ankle': 'Lower Limb',
    Chest: 'Thorax',
    'Spine & Back': 'Thorax',
    Shoulder: 'Upper Limb',
    'Elbow & Forearm': 'Upper Limb',
    'Hand & Wrist': 'Upper Limb',
};

export const HANDOUT_FORMAT_CATEGORY = 'Handouts';

export const BODY_AREA_OPTIONS = Object.keys(BODY_AREA_PARENT_BY_LABEL);

export const CONDITION_CATEGORY_OPTIONS = [
    'Cardiorespiratory',
    'Chronic conditions',
    'General principles',
    'Medical conditions',
    'Musculoskeletal',
    'Neurology',
    'Paediatrics',
    'Rheumatology',
    "Women's health",
];

const normalize = (value) => (value || '').toString().trim().toLowerCase();

export const deepContainsCategory = (value, target) => {
    const targetNormalized = normalize(target);
    if (!targetNormalized) return false;

    if (Array.isArray(value)) return value.some((entry) => deepContainsCategory(entry, targetNormalized));
    if (value && typeof value === 'object') {
        return Object.entries(value).some(
            ([key, nestedValue]) =>
                normalize(key) === targetNormalized || deepContainsCategory(nestedValue, targetNormalized),
        );
    }
    if (typeof value === 'string') return normalize(value) === targetNormalized;
    return false;
};

export const getSelectedPlatformCategories = (categories = {}) => ({
    bodyAreas: BODY_AREA_OPTIONS.filter((label) => deepContainsCategory(categories, label)),
    conditionCategories: CONDITION_CATEGORY_OPTIONS.filter((label) => deepContainsCategory(categories, label)),
});

export const buildPlatformCategories = ({ bodyAreas = [], conditionCategories = [] }) => {
    const categories = {
        [HANDOUT_FORMAT_CATEGORY]: [],
    };

    if (bodyAreas.length > 0) {
        categories['Body Area'] = bodyAreas.reduce((accumulator, label) => {
            const parent = BODY_AREA_PARENT_BY_LABEL[label] || label;
            const values = Array.isArray(accumulator[parent]) ? accumulator[parent] : [];
            accumulator[parent] = values.includes(label) ? values : [...values, label];
            return accumulator;
        }, {});
    }

    conditionCategories.forEach((label) => {
        categories[label] = [];
    });

    return categories;
};

export const getPlatformCategoryFilterGroups = () => [
    { key: 'bodyAreas', title: 'By Body Area', options: BODY_AREA_OPTIONS },
    { key: 'conditionCategories', title: 'By Condition', options: CONDITION_CATEGORY_OPTIONS },
];
